module.exports = __webpack_public_path__ + "static/img/201125-3.c4928cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/201125-3.jpg
// module id = 8wXg
// module chunks = 0